import THead from './THead';

export default THead;
